export class Ball {
  constructor(public ballNumber: number, public chosenBall: boolean = false) {}
}
